import script from "./vmsChooseMyOrganization.vue?vue&type=script&lang=js"
export * from "./vmsChooseMyOrganization.vue?vue&type=script&lang=js"

import "./vmsChooseMyOrganization.vue?vue&type=style&index=0&id=1349cf92&lang=css"
import "./vmsChooseMyOrganization.vue?vue&type=style&index=1&id=1349cf92&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1349cf92"]])

export default __exports__